let isModalOpen = false;

function showToast(message, type = "info") {
  try {
    const container = document.querySelector(".global-toast-container");
    if (!container) {
      console.warn(
        "Toast container not found in DOM. Ensure snippets/global-toast.liquid is rendered."
      );
      return;
    }

    const toast = document.createElement("div");
    toast.className = `global-toast global-toast--${type}`;
    toast.textContent = message;
    container.appendChild(toast);

    setTimeout(() => toast.classList.add("global-toast--visible"), 50);
    setTimeout(() => {
      toast.classList.remove("global-toast--visible");
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  } catch (err) {
    console.warn("Toast error", err);
  }
}

window.openVariantModal = function (
  cartKey,
  productId,
  productHandle,
  currentVariantId
) {
  ensureModalExists();
  isModalOpen = false;
  loadProductVariants(productHandle, currentVariantId, cartKey);
  showModal();
};

function getModalElements() {
  let overlay = document.getElementById("variant-modal-overlay");
  let container = document.getElementById("variant-modal-container");

  if (!overlay || !container) {
    ensureModalExists();
    overlay = document.getElementById("variant-modal-overlay");
    container = document.getElementById("variant-modal-container");
  }

  if (overlay && container) {
    if (!overlay.hasAttribute("data-listener-added")) {
      overlay.addEventListener("click", closeVariantModal);
      overlay.setAttribute("data-listener-added", "true");
    }
    return { overlay, container };
  }
  return null;
}

function showModal() {
  const modal = getModalElements();
  if (!modal) return;

  isModalOpen = true;
  modal.overlay.style.display = "block";
  modal.container.style.display = "flex";

  requestAnimationFrame(() => {
    modal.overlay.style.opacity = "1";
    modal.container.style.transform = "translateY(0)";
  });

  document.body.style.overflow = "hidden";
}

window.closeVariantModal = function () {
  const modal = getModalElements();
  if (!modal) {
    return;
  }

  isModalOpen = false;
  modal.overlay.style.opacity = "0";
  modal.container.style.transform = "translateY(100%)";

  setTimeout(() => {
    modal.overlay.style.display = "none";
    modal.container.style.display = "none";
    document.body.style.overflow = "";
  }, 300);
};

async function loadProductVariants(productHandle, currentVariantId, cartKey) {
  try {
    const grid = document.getElementById("variant-options-grid");
    if (!grid) return;

    const variantOptionsContainer =
      document.querySelector(
        `.variant-options-html[data-product-handle="${productHandle}"]`
      ) ||
      document.querySelector(
        `.variant-options-html[data-product-id="${productHandle}"]`
      ) ||
      document.querySelector(".variant-options-html");

    if (!variantOptionsContainer) {
      console.error("Variant options container not found");
      grid.innerHTML = '<p class="error-message">Variant options not found</p>';
      return;
    }

    grid.innerHTML = variantOptionsContainer.innerHTML;

    const variantOptions = grid.querySelectorAll(".variant-modal-option");

    variantOptions.forEach((option) => {
      const variantId = option.dataset.variantId;
      const available = option.dataset.soldOut !== "true";
      const isCurrentVariant =
        variantId === currentVariantId ||
        variantId === String(currentVariantId);

      if (isCurrentVariant) {
        option.classList.add("current-variant");

        const sizeSpan = option.querySelector(".variant-size");
        if (sizeSpan && !sizeSpan.querySelector(".selected-indicator")) {
          const indicator = document.createElement("span");
          sizeSpan.appendChild(indicator);
        }

        return;
      }

      if (available && !isCurrentVariant) {
        option.addEventListener("click", async (e) => {
          e.preventDefault();
          e.stopPropagation();

          const sizeSpan = option.querySelector(".variant-size");
          const size = sizeSpan ? sizeSpan.textContent : "";

          await selectVariant(variantId, size, cartKey, available);
        });
      }
    });
  } catch (error) {
    console.error("Error in loadProductVariants:", error);
    const grid = document.getElementById("variant-options-grid");
    if (grid) {
      grid.innerHTML =
        '<p class="error-message">Failed to load variants. Please try again.</p>';
    }
  }
}

async function selectVariant(variantId, value, cartKey, available) {
  if (!available) {
    console.warn("Variant not available:", variantId);
    return;
  }

  try {
    if (isModalOpen) {
      closeVariantModal();
    }

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.showLoader === "function") {
      cartDrawer.showLoader();
    }

    const cartResponse = await fetch("/cart.js");
    if (!cartResponse.ok) {
      throw new Error("Failed to fetch cart data");
    }

    const cartData = await cartResponse.json();

    window.dispatchEvent(
      new CustomEvent("cart:count-update", {
        detail: {
          count: cartData.item_count,
        },
      })
    );

    const currentItem = cartData.items.find((item) => item.key === cartKey);

    if (!currentItem) {
      throw new Error("Cart item not found");
    }

    const originalQuantity = currentItem.quantity;

    const variantIdNum = parseInt(variantId, 10);
    const existingOtherLinesQty = cartData.items
      .filter((it) => it.key !== cartKey)
      .filter((it) => Number(it.variant_id) === variantIdNum)
      .reduce((sum, it) => sum + (it.quantity || 0), 0);

    const MAX_PER_VARIANT = 5;
    let desiredQuantity = originalQuantity;
    const allowed = MAX_PER_VARIANT - existingOtherLinesQty;

    if (allowed <= 0) {
      showToast("Quantity limit exceedded.", "warning");
      if (cartDrawer && typeof cartDrawer.hideLoader === "function") {
        cartDrawer.hideLoader();
      }
      return;
    }

    if (desiredQuantity > allowed) {
      desiredQuantity = allowed;
      showToast(`Quantity set to ${desiredQuantity}`, "warning");
    }

    const removeResponse = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: cartKey,
        quantity: 0,
      }),
    });

    if (!removeResponse.ok) {
      const err = await removeResponse.json();
      throw new Error(
        "Failed to remove old variant: " +
          (err.message || removeResponse.status)
      );
    }

    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: desiredQuantity,
      }),
    });

    if (!addResponse.ok) {
      const err = await addResponse.json();
      throw new Error(
        "Failed to add new variant: " + (err.message || addResponse.status)
      );
    }

    const addedItem = await addResponse.json();
    const newKey = addedItem?.key || addedItem?.items?.[0]?.key;
    if (newKey && typeof window.replaceCartItemOrderKey === "function") {
      window.replaceCartItemOrderKey(cartKey, newKey);
    }

    // No network settling time needed — this buffers the variant-modal's own 300ms close transition from being cut off by the drawer's innerHTML swap.
    setTimeout(async () => {
      if (cartDrawer && typeof cartDrawer.render === "function") {
        await cartDrawer.render();
      } else {
        window.dispatchEvent(new CustomEvent("cart:updated"));
      }
      window.dispatchEvent(new CustomEvent("cart:loaded"));
    }, 200);
  } catch (error) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.hideLoader === "function") {
      cartDrawer.hideLoader();
    }
    window.dispatchEvent(new CustomEvent("cart:loaded"));
  }
}

function ensureModalExists() {
  const overlay = document.getElementById("variant-modal-overlay");
  const container = document.getElementById("variant-modal-container");

  if (overlay && container) {
    if (!overlay.hasAttribute("data-listener-added")) {
      overlay.addEventListener("click", (e) => {
        if (e.target === overlay) closeVariantModal();
      });
      overlay.setAttribute("data-listener-added", "true");
    }

    const closeBtn = container.querySelector(".variant-modal-close");
    if (closeBtn && !closeBtn.hasAttribute("data-listener-added")) {
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeVariantModal();
      });
      closeBtn.setAttribute("data-listener-added", "true");
    }
    return { overlay, container };
  }

  return null;
}

document.addEventListener("DOMContentLoaded", function () {
  ensureModalExists();
});

document.addEventListener("click", function (e) {
  const swatch = e.target.closest("[data-select-variant]");
  if (!swatch) return;

  selectVariant(
    swatch.dataset.variantId,
    swatch.dataset.colorValue,
    swatch.dataset.cartKey,
    swatch.dataset.available === "true"
  );
});

window.addEventListener("cart:updated", function () {
  setTimeout(() => {
    ensureModalExists();
    isModalOpen = false;
  }, 150);
});

